import styled from 'styled-components';

import theme from '../../assets/theme';
import { zIndexes } from '../../utils/zIndexes';

export const DesignerTopBarContainer = styled.div`
  height: 60px;
  width: 100%;
  background: ${theme.colors.white};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  z-index: ${zIndexes('CREATOR_TOP_BAR')};
`;

export const DesignerTopBarContainerAnimated = styled.div`
  height: 60px;
  width: 100%;
  background: ${theme.colors.white};
  background-size: 400% 400%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
  z-index: ${zIndexes('CREATOR_TOP_BAR')};
`;
